import React, { Component } from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import history from '../libraries/History';
import session from '../models/Session';

import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Media } from 'reactstrap';

const styles = {
  root: {
    flexGrow: 1,
  },
  flex: {
    flexGrow: 1,
    fontFamily: "'Lato'",
    color: '#34A5DA !important',
    fontWeight: '600',
  },
  avatar: {
    margin: 10,
  },
  headerMenu: {
    fontFamily: "'Lato'",
    color: '#1F1F1F !important',
    fontSize: '0.875rem',
    cursor: 'pointer',
    marginRight: '1rem',
  },
  header: {
    backgroundColor: '#FFFFFF !important',
    boxShadow: 'none',
    borderBottom: '1px solid #e8eae9',
  },
  imgWrapper: {
    width: '2rem',
    height: '2rem',
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    fontSize: '1.25rem',
    flexShrink: 0,
    fontFamily: 'Lato',
    alignItems: 'center',
    userSelect: 'none',
    borderRadius: '50%',
    justifyContent: 'center'
  },
  img: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    objectFit: 'cover',
  },
};

class Header extends Component {

  state = {
    isOpen: false, 
    user: null, 
  }

  options = {
    getPropsFromSession: ["user"]
  }

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false,
      user: {},
    };
  }

  async checkSession() {
    await session.fetchLocal();
    
    console.log('header:checkSession',session.user);
    this.setState({
       user: session.user
    });
  }

  componentDidMount() {
    this.checkSession();
  }

  // componentDidUpdate() {
  //   this.checkSession()ll;;
  // }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  renderJamRecipes = () => {
    history.push('/create');
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Navbar color="light" light className={classes.header} expand="md">
          <NavbarBrand href="/" className={classes.flex}>STORY JAM</NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="/components/" className={classes.headerMenu}>Search</NavLink>
              </NavItem>
              <NavItem>
                <NavLink onClick={this.renderJamRecipes} className={classes.headerMenu}>Create a Jam</NavLink>
              </NavItem>
              {console.log(this.state.user)}
              { this.state.user._id ? (
                <NavItem className={classes.imgWrapper}>
                <Media 
                  src={this.state.user.image || "https://static.makeuseof.com/wp-content/uploads/2015/11/perfect-profile-picture-all-about-face.jpg"} 
                  className={classes.img} 
                  alt="Generic placeholder image" 
                />
              </NavItem>
              ) : (
                <NavItem>
                  <NavLink href="/login" className={classes.headerMenu}>Login</NavLink>
                </NavItem>
              ) }          
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default injectSheet(styles)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js